import React from 'react'
import Fragment from '../common/fragment'


function FragmentAT(props) {
  return (
    <Fragment pos="t" {...props}>
      <p>
“Una fábrica donde es posible robar piezas de metal y algunos instrumentos. Los
trabajadores no son revisados. Pero las puertas de salida son magnéticas. Todo
comentario es superfluo”. Eisenstein, Guion para El Capital.
      </p>
    </Fragment>
  )
}


export default FragmentAT
